import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import { useSelector } from "react-redux";
import Header from "../components/layout/Header";
import { Helmet } from "react-helmet-async";

const ParentAppIframe = () => {
  const userId = useSelector((state) => state.currentProfile.data._id);

  // Simulate a short-lived SSO token (you should generate a real JWT on the backend)
  const ssoToken = btoa(JSON.stringify({ userId })); // ✅ TODO Replace with real token in production

  // const iframeUrl = `http://localhost:3001?ssoToken=${encodeURIComponent(
  //   ssoToken
  // )}`;
  const iframeUrl = `https://ai.loonlog.ca?ssoToken=${encodeURIComponent(
    ssoToken,
  )}`; // use in production

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        {/* <IonHeader mode="ios">
          <Header />
        </IonHeader> */}
        <IonContent>
          <iframe
            id="child-iframe"
            src={iframeUrl}
            style={{ width: "100%", height: "100vh", border: "none" }}
            allow="clipboard-write"
            sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
            title="LoonLock"
          />
        </IonContent>
      </IonPage>
    </>
  );
};

export default ParentAppIframe;
